module.exports = __webpack_public_path__ + "static/media/linkedin-line.63d77cfb.svg";